import React, { useState, useEffect, useContext, useRef } from 'react'
import config from '../../config'
import MyNavBar from '../myComponents/MyHeader/MyNavBar'
import MyHeaderBg from '../myComponents/MyHeaderBg/MyHeaderBg'
import IndexList from '../myComponents/IndexList/IndexList'
import * as Styles from './RegisterStyle'
import StaffIcon from '../Icons/StaffIcon'
import People from '../Icons/People'
import Case from '../Icons/Case'
import Stethoscope from '../Icons/Stethoscope'
import Hospital from '../Icons/Hospital'
import Address from '../Icons/Address'
import Bed from '../Icons/Bed'
import AllergenIcon from '../Icons/Allergen'
import Phone from '../Icons/Phone'
import Lock from '../Icons/Lock'
import DeleteIcon from '../Icons/DeleteIcon'
import { Session } from '../../contexts/Session'
import { Checkbox, InputItem, Toast, List, Picker, Modal, Icon } from 'antd-mobile'
import intl from 'react-intl-universal'
import './Register.css'
import request from '../../utils/request'
import { HospitalBasicInfoContext } from '../../contexts/HospitalBasicInfo'
import { LanguageContext } from '../../contexts/LanguageContext'
import RenderSeconds from './useInterval'
import MyModal from '../myComponents/MyModal/MyModal'
import PrivacyPolicy from './PrivacyPolicy'

const FormData = require('form-data')
// const mammoth = require('mammoth')
export default function Register (props) {
  const AgreeItem = Checkbox.AgreeItem
  const form = new FormData()
  const [number, setNumber] = useState('') // 住院号
  const [patientName, setPatientName] = useState('') // 病员姓名
  const [selectedDietaryAdvice, setSelectedDietaryAdvice] = useState([]) // 饮食医嘱(只有value)
  const [selectedDietaryAdviceObj, setSelectedDietaryAdviceObj] = useState([]) // 饮食医嘱(既有value也有id)
  const [floor, setFloor] = useState({}) // 楼层
  const [area, setArea] = useState({}) // 病区
  const [bedId, setBedId] = useState({}) // 床位号
  const [mobile, setMobile] = useState('') // 手机号码
  const [verificationCode, setVerificationCode] = useState('') // 验证码
  const [selected, setSelected] = useState(false) // 用户是否勾选了同意服务
  const [allergen, setAllergen] = useState('') // 过敏源

  const [startCount, setStartCount] = useState(false) // 倒计时
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalTitle, setModalTitle] = useState('') // 提示信息弹窗的提示标题内容
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [editable, setEditable] = useState(false) // 文本框是否可编辑（住院号除外）
  const [showOKButton, setShowOKButton] = useState(true) // 住院号后面的确定按钮是否显示
  const [numberEditable, setNumberEditable] = useState(true) // 住院号是否可编辑
  const [positionEditable, setPositionEditable] = useState(true) // 床位信息是否可编辑
  const [floorsArr, setFloorsArr] = useState([]) // 从后台读取的所有楼层数组
  const [selectedPosition, setSelectedPosition] = useState([]) // 用户选择的床位数组

  const [showClause, setShowClause] = useState(false) // 是否展示用户条款
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false) // 是否展示用户隐私条款

  const [confirmNumber, setConfirmNumber] = useState(false) // 住院号是否高亮
  const [confirmName, setConfirmName] = useState(false) // 姓名是否高亮
  const [confirmDietaryAdvice, setConfirmDietaryAdvice] = useState(false) // 饮食医嘱是否高亮
  const [confirmPosition, setConfirmPosition] = useState(false) // 病区楼层床位号是否高亮
  const [confirmPhone, setConfirmPhone] = useState(false) // 手机号是否高亮
  const [confirmCode, setConfirmCode] = useState(false) // 验证码是否高亮

  // const [patientInfo, setPatientInfo] = useState({}) // 根据住院号获取的病员信息
  const [foodAdviceDataSource, setFoodAdviceDataSource] = useState([]) // 饮食医嘱的option标签数组
  const [dataSource, setDataSource] = useState([]) // 该医院的所有床位数组(包含了病区，楼层，床位的所有数据)，会根据用户的选择动态变化
  const [deviceHeight, setDeviceHeight] = useState(0) // 设备的高度
  const HospitalBasicInfo = useContext(HospitalBasicInfoContext) // 医院基础信息context
  const SessionContext = useContext(Session) // 包含了病员信息，用户信息(JSON格式)context
  const Language = useContext(LanguageContext) // 包含了病员信息，用户信息(JSON格式)context

  const registerButton = useRef('registerButton') // 注册按钮ref
  const [visible, setVisible] = useState(false)
  const [defaultValue, setDefaultValue] = useState([])

  const [patientInfoArray, setPatientInfoArray] = useState([]) // 根据床头二维码获得的病员信息
  const [pickerData, setPickerData] = useState([]) // 选择病员的弹窗（PickerView）数据源
  const [ifShowPickerView, setIfShowPickerView] = useState(false) // 是否展示选择病员的弹窗（PickerView）
  const [selectedPatient, setSelectedPatient] = useState({})
  const [showPatientInfoModal, setShowPatientInfoModal] = useState(false) // 展示多个病员中被选中的病员信息
  const [showRefuseToChoosePatientModal, setShowRefuseToChoosePatientModal] = useState(false) // 展示多个病员中被选中的病员信息

  const [userTerm, setUserTerm] = useState(null)

  const [flag, setFlag] = useState(false)

  const inputCode = useRef('inputCode')
  const inputTelephone = useRef('inputText')

  const zhUserTerm = `UserTerms/${window.localStorage.getItem('sdxHisCode')}/zh.docx` // 中文用户条款
  const enUserTerm = `UserTerms/${window.localStorage.getItem('sdxHisCode')}/en.docx` // 英文用户条款

  useEffect(() => {
    setDeviceHeight(window.innerHeight)
    inputCode.current.onInputBlur = () => {
      window.scroll(0, 0)
    }
    inputTelephone.current.onInputBlur = () => {
      window.scroll(0, 0)
    }
  }, [])

  /**
   * 将context里的医院的病区，楼层，床位等数据，整合成符合Picker组件级联时的数据格式
   */
  useEffect(() => {
    // console.log(HospitalBasicInfo.hospitalBasicInfo)
    if (JSON.stringify(HospitalBasicInfo.hospitalBasicInfo) !== '{}') {
      // renderFoodAdvicesOptions()
      getAllFloors()
      fuliterFoodAdvice()
    }
    // eslint-disable-next-line
  }, [HospitalBasicInfo])

  /**
   * 根据Seesion中的数据，填充以及判断用户是否能输入
   */
  useEffect(() => {
    if (!flag) {
      // console.log(SessionContext)
      let patientInfo = {} // 存放被选中的对象格式的病员信息
      let tempPatientArray = [...SessionContext.patientInfo] // 存放由床头二维码获取的病员信息
      // if (tempPatientArray.length === 1) { // 说明床头二维码只获得一个用户信息
      //   patientInfo = tempPatientArray[0]
      //   setPatientInfoArray([...tempPatientArray])
      //   setPickerData([...tempPatientArray])
      //   setIfShowPickerView(false)
      // } else
      if (tempPatientArray.length >= 1) { // 说明床头二维码获得了一个或多个用户信息
        tempPatientArray = [...tempPatientArray]
        let result = []
        result = tempPatientArray.map((patient) => {
          // eslint-disable-next-line
          return { label: `${patient.pid}　　${patient.patientName}`, value: patient.pid }
        })
        setPickerData([...result])
        setPatientInfoArray([...tempPatientArray])
        setIfShowPickerView(true)
      } else { // 说明床头二维码没有获得用户信息
        patientInfo = SessionContext.patientInfoByWristband
        tempPatientArray = []
        setPatientInfoArray([])
        setPickerData([])
        setIfShowPickerView(false)
      }
      if (tempPatientArray.length > 1) { // 说明床头二维码获得的用户信息为多个

      } else { // 说明床头二维码获得的用户信息为1个或0个
        if (JSON.stringify(patientInfo) !== '{}') { // 说明：此类情况下，用户一定是通过床头二维码或腕带已经获取了病员信息
          setPatientInfo(patientInfo) // 填充病员所有信息
          setNumberEditable(false) // 禁止修改住院号
          setEditable(false) // 禁止修改用户名和饮食医嘱
          setPositionEditable(false) // 禁止修改床位信息
        } else { // 此类情况下，用户未通过床头二维码或腕带获取病员信息
          if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo) {
            if (JSON.stringify(SessionContext.positionInfo) !== '{}') { // 此类情况，虽然用户没有病员具体信息，但是通过床头二维码获取了用户的床位信息
              setPatientPositionInfo() // 填充病员的床位信息
              setPositionEditable(false) // 禁止用户修改床位信息
              if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
                setNumberEditable(true) // 允许修改住院号
                setEditable(false) // 禁止修改用户名和饮食医嘱
              } else {
                setNumberEditable(true) // 允许修改住院号
                setEditable(true) // 允许修改用户名和饮食医嘱
              }
            } else { // 此类情况，用户通过公众号进入系统，且没有病员的任何信息
              setNumberEditable(true) // 允许修改住院号
              if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
                setPositionEditable(false) // 禁止用户修改床位信息
                setEditable(false) // 禁止修改用户名和饮食医嘱
              } else {
                setPositionEditable(true) // 允许用户修改床位信息
                setEditable(true) // 允许修改用户名和饮食医嘱
              }
            }
          }
        }
      }
    }
    // eslint-disable-next-line
  }, [SessionContext, HospitalBasicInfo])

  useEffect(() => {
    getUserTerm()
    // eslint-disable-next-line
  }, [Language.locale])

  /**
   * 重定向到微信授权页面
   */
  function redirectToAuth () {
    const hisCode = window.localStorage.getItem('sdxHisCode') ? window.localStorage.getItem('sdxHisCode') : ''
    const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId') ? `/${window.localStorage.getItem('sdxPatPositionId')}` : ''
    const indexUrl = `/index/${hisCode}${sdxPatPositionId}`
    Toast.info(
      intl.get('RedirectToAuth'), 2,
      () => {
        // console.log(`即将跳转${config.server}/v1/wxcommons/oauth2?return_url=%23${indexUrl}`)
        window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=%23${indexUrl}`)
        // window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=${indexUrl}`)
      }, true)
  }

  function getUserTerm () {
    request('/v1/oss/sts', {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then(async (res) => {
      if (!res.error) {
        const OSS = require('ali-oss')
        const client = new OSS({
          region: config.ossRegion,
          accessKeyId: res._raw.credentials.accessKeyId,
          accessKeySecret: res._raw.credentials.accessKeySecret,
          bucket: config.ossBucket,
          endpoint: config.ossEndpoint,
          stsToken: res._raw.credentials.securityToken
        })
        const userTermLanguage = Language.locale === 'en' ? enUserTerm : zhUserTerm
        const fileTxt = client.signatureUrl(userTermLanguage, {
          expires: 43200
        })
        main(fileTxt)
      } else {
        console.log(res.message)
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  async function main (url) {
    const mammoth = window.mammoth
    var options = {
      styleMap: [
        'i => strong',
        'u => u',
        'strike => strike'
      ]
    }
    // const historyOrderBg = require(url)
    // console.log(historyOrderBg)
    // let historyOrderBg = './test.docx'

    const res1 = await fetch(url)
    const arrayBuffer = await res1.arrayBuffer()

    mammoth.convertToHtml({ arrayBuffer }, options)
      .then(function (result) {
        var html = result.value // The generated HTML
        setUserTerm(html)
        // console.log(html)
      })
      .done()
  }

  /**
   * 用户选择病员
   */
  function handleOnSelectPatient (value) {
    let patient = {}
    patient = patientInfoArray.filter((patient) => patient.pid === value[0])[0]
    const patientInfoDom = <table style={{ width: '100%' }}>
      <tbody align='left'>
        <tr>
          <td>{intl.get('PatientName')}</td>
          <td>{patient.patientName}</td>
        </tr>
        <tr>
          <td colSpan={2} style={{ borderBottom: '1px solid #EFEFEF' }} />
        </tr>
        <tr>
          <td>{intl.get('HospitalizationNumber')}</td>
          <td>{patient.pid}</td>
        </tr>
      </tbody>
    </table>
    setIfShowPickerView(false)
    setShowPatientInfoModal(true)
    setModalTitle(intl.get('SureToChoosePatient'))
    setModalInfo(patientInfoDom)
    setSelectedPatient(patient)
  }

  /**
   * 根据床位号查询出的病人信息不包括用户想绑定的人
   */
  function handleOnRefuseChoosePatient () {
    setIfShowPickerView(false)
    setShowRefuseToChoosePatientModal(true)
    setModalTitle(intl.get('Tips'))
    setModalInfo(intl.get('SureToRefuseToChoosePatient'))
  }

  /**
   * 自动填充病员信息
   */
  function setPatientInfo (patientData) {
    const patientInfo = patientData
    const temp = []
    const tempObj = []
    const tempId = []
    patientInfo.foodAdvices.map((advice) => {
      temp.push(advice.advice)
      tempObj.push({ id: advice.id, value: advice.advice })
      tempId.push(advice.id)
    })
    setNumber(patientInfo.pid)
    setFloor({ floorId: patientInfo.lc_ID, floorName: patientInfo.lc_Name })
    setArea({ areaId: patientInfo.bq_ID, areaName: patientInfo.bq_Name })
    setBedId({ bedId: patientInfo.patPositionID, bedName: patientInfo.patPositionName })
    setPatientName(patientInfo.patientName)
    setAllergen(patientInfo.allergies)
    setSelectedDietaryAdvice(temp)
    setSelectedDietaryAdviceObj(tempObj)
    setDefaultValue(tempId)
    setEditable(false)
    setShowOKButton(false)
  }

  function setPatientPositionInfo () {
    const positionInfo = SessionContext.positionInfo
    setFloor({ floorId: positionInfo.lc_ID, floorName: positionInfo.lc_Name })
    setArea({ areaId: positionInfo.bq_ID, areaName: positionInfo.bq_Name })
    setBedId({ bedId: positionInfo.patPositionID, bedName: positionInfo.patPositionName })
  }

  function fuliterFoodAdvice () {
    const foodAdvices = HospitalBasicInfo.hospitalBasicInfo.foodAdvices
    const dataSource = []
    foodAdvices.map((item) => {
      const tempObj = {}
      tempObj.value = item.id
      tempObj.label = item.advice
      tempObj.spell = item.spell
      dataSource.push(tempObj)
    })
    setFoodAdviceDataSource(dataSource)
  }

  /**
   * 重置所有输入框状态
   */
  function resetInputEditState () {
    let patientInfo = {}
    if (SessionContext.patientInfo.length !== 0) {
      patientInfo = SessionContext.patientInfo
    } else {
      patientInfo = SessionContext.patientInfoByWristband
    }
    if (JSON.stringify(patientInfo) !== '{}') { // 说明：此类情况下，用户一定是通过床头二维码或腕带已经获取了病员信息
      setPatientInfo(patientInfo) // 填充病员所有信息
      setNumberEditable(false) // 禁止修改床位号
      setEditable(false) // 禁止修改用户名和饮食医嘱
      setPositionEditable(false) // 禁止修改床位信息
    } else { // 此类情况下，用户未通过床头二维码或腕带获取病员信息
      if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo) {
        if (JSON.stringify(SessionContext.positionInfo) !== '{}') { // 此类情况，虽然用户没有病员具体信息，但是通过床头二维码获取了用户的床位信息
          setPatientPositionInfo() // 填充病员的床位信息
          setPositionEditable(false) // 禁止用户修改床位信息

          setPatientName('')
          setAllergen('')
          setSelectedDietaryAdvice([])
          setSelectedDietaryAdviceObj([])
          setDefaultValue([])

          if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
            setNumberEditable(true) // 禁止修改床位号
            setEditable(false) // 禁止修改用户名和饮食医嘱
          } else {
            setNumberEditable(true) // 允许修改床位号
            setEditable(true) // 允许修改用户名和饮食医嘱
          }
        } else { // 此类情况，用户通过公众号进入系统，且没有病员的任何信息
          setFloor({})
          setArea({})
          setBedId({})
          setPatientName('')
          setAllergen('')
          setSelectedDietaryAdvice([])
          setSelectedDietaryAdviceObj([])
          setDefaultValue([])

          setNumberEditable(true) // 允许修改住院号
          if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
            setPositionEditable(false) // 禁止用户修改床位信息
            setEditable(false) // 禁止修改用户名和饮食医嘱
          } else {
            setPositionEditable(true) // 允许用户修改床位信息
            setEditable(true) // 允许修改用户名和饮食医嘱
          }
        }
      }
    }
  }

  /**
   * 根据住院号获取病员信息
   */
  function getPatientInfoByPId () {
    // console.log(HospitalBasicInfo)
    request(`/v1/patients/${number}?hospitalId=${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      // console.log(res)
      if (!res.error) {
        if (res.data.id === undefined) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(intl.get('EnterPIDAgain'))
          // setFloor({})
          // setArea({})
          // setBedId({})
          // setPatientName('')
          // setSelectedDietaryAdvice([])
          // setSelectedDietaryAdviceObj([])
          // setDefaultValue([])
          setConfirmNumber(false)
          setConfirmName(false)
          setConfirmDietaryAdvice(false)
          setConfirmPosition(false)
          setConfirmPhone(false)
          setConfirmCode(false)

          resetInputEditState() // 重新设置输入框的是否可编辑状态
          // if (!HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
          //   setEditable(true)
          //   setPositionEditable(true)
          // } else {
          //   setEditable(false)
          //   setPositionEditable(false)
          // }
        } else {
          const temp = []
          const tempId = []
          const tempObj = []
          res.data.foodAdvices.map((advice) => {
            temp.push(advice.advice)
            tempId.push(advice.id)
            tempObj.push({ id: advice.id, value: advice.advice })
          })
          // setPatientInfo(res.data)
          setFloor({ floorId: res.data.lc_ID, floorName: res.data.lc_Name })
          setArea({ areaId: res.data.bq_ID, areaName: res.data.bq_Name })
          setBedId({ bedId: res.data.patPositionID, bedName: res.data.patPositionName })
          setPatientName(res.data.patientName)
          setAllergen(res.data.allergies)
          setSelectedDietaryAdvice(temp)
          setSelectedDietaryAdviceObj(tempObj)
          setDefaultValue(tempId)
          setEditable(false)
          setPositionEditable(false)

          setConfirmNumber(false)
          setConfirmName(false)
          setConfirmDietaryAdvice(false)
          setConfirmPosition(false)
          setConfirmPhone(false)
          setConfirmCode(false)
        }
      } else {
        if (['1001', '1002', '1003'].includes(res.code)) {
          // setFloor({})
          // setArea({})
          // setBedId({})
          // setPatientName('')
          // setSelectedDietaryAdvice([])
          // setSelectedDietaryAdviceObj([])
          // setDefaultValue([])
          setConfirmNumber(false)
          setConfirmName(false)
          setConfirmDietaryAdvice(false)
          setConfirmPosition(false)
          setConfirmPhone(false)
          setConfirmCode(false)

          resetInputEditState()
          // if (!HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
          //   setEditable(true)
          //   setPositionEditable(true)
          // } else {
          //   setEditable(false)
          //   setPositionEditable(false)
          // }

          if (Number(res.code) === 1001) {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            // setModalInfo(intl.get('QueryPetientInfo1001'))
            setModalInfo(res.message)
          } else if (Number(res.code) === 1002) {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            // setModalInfo(intl.get('QueryPetientInfo1002'))
            setModalInfo(res.message)
          } else if (Number(res.code) === 1003) {
            setShowModal(true)
            // setModalInfo(intl.get('QueryPetientInfo1003'))
            setModalTitle(intl.get('Tips'))
            setModalInfo(res.message)
          } else {
            console.log(res.message)
          }
        } else if (res.code && res.code === '2000') {
          redirectToAuth()
        } else {
          console.log(res.message)
        }
        // Toast.info('获取该病员信息出错!')
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 返回住院号的确认按钮
   */
  function RenderNumberConfirmButton () {
    return (
      <Styles.NumberConfirmButton onClick={() => handleOnClickConfirm()}>{intl.get('Search')}</Styles.NumberConfirmButton>
    )
  }

  /**
   * 返回文本框的删除按钮
   */
  function RenderDeleteIcon (props) {
    const { type } = props
    return (
      type && type.toString().length > 0 ? <Styles.DeleteIconContainer onClick={props.onClick}><DeleteIcon width={20} height={20} /></Styles.DeleteIconContainer> : null
    )
  }
  /**
   * 点击住院号的确认按钮
   */
  function handleOnClickConfirm () {
    if (number.length <= 0) {
      setShowModal(true)
      setModalTitle(intl.get('Tips'))
      setModalInfo(intl.get('EnterPID'))
    } else {
      getPatientInfoByPId()
    }
  }

  function handleOnEndCount () {
    setStartCount(false)
  }

  /**
   * 点击获取验证码的按钮触发
   */
  function handleOnGetVerificationCode (ifStartCount = true) {
    // console.log(mobile)
    // console.log(mobile.replace(/\s*/g, ''))
    const mobileTemp = mobile.replace(/\s*/g, '')
    if (!(/^(?=\d{11}$)^1(?:3\d|4[57]|5[^4\D]|66|7[^249\D]|8\d|9[89])\d{8}$/).test(mobileTemp)) {
      setShowModal(true)
      setModalTitle(intl.get('Tips'))
      setModalInfo(intl.get('EnterRightFormatPhone'))
      return false
    }
    if (mobile.length > 0) {
      setStartCount(ifStartCount)
      if (ifStartCount) {
        request(`/v1/codes/smsCode?mobile=${mobile.replace(/\s*/g, '')}`, {
          method: 'GET',
          headers: {
            'Accept-Language': Language.acceptLanguage
          }
        }).then((res) => {
          // console.log(res)
          if (!res.error) {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            setModalInfo(intl.get('SuccessfullyGetCode'))
          } else {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            setModalInfo(res.message)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    } else {
      setShowModal(true)
      setModalTitle(intl.get('Tips'))
      setModalInfo(intl.get('EnterPhoneNumber'))
    }
  }

  /**
   * 床位选择点击取消触发事件
   */
  // function handlePickerOnCancel () {
  //   setSelectedPosition([])
  //   setConfirmPosition(true)
  //   setArea({})
  //   setFloor({})
  //   setBedId({})
  // }

  /**
   * 床位选择点击确定触发事件
   */
  function handlePickerOnOk (value) {
    setSelectedPosition(value)
    if (value.length === 3) {
      setConfirmPosition(false)
      setFloor(JSON.parse(value[0]))
      setArea(JSON.parse(value[1]))
      setBedId(JSON.parse(value[2]))
    } else {
      setConfirmPosition(true)
    }
  }

  /**
   * 当用户更改每一列的选择时改变其他列的显示数据
   * 病区->楼层->床位
   */
  function handleOnColChange (value) {
    setSelectedPosition(value)
    let areaIndex = 0
    let floorIndex = 0
    value.map((item, index) => {
      const itemObj = JSON.parse(item)
      if (index === 0) {
        floorIndex = itemObj.index
      }
      if (index === 1) {
        areaIndex = itemObj.index
      }
    })
    getAreasByFloor(floorsArr.slice(0), floorIndex, areaIndex)
  }

  /**
   * 获取所有的病区
   */
  function getAllFloors (floorIndex = 0, areaIndex = 0) {
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/lc`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        setFloorsArr(res.data.slice(0))
        getAreasByFloor(res.data, floorIndex, areaIndex)
      } else if (res.code) {
        if (Number(res.code) === 2000) {
          redirectToAuth()
        } else {
          Toast.info('获取所有病区出错')
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据用户选择的病区去获取该病区的所有楼层
   */
  function getAreasByFloor (floorsTemp, floorIndex, areaIndex) {
    Toast.loading('', 0, () => { }, true)
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/${floorsTemp[floorIndex].id}/bq`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (res.data) {
          getBedsByFloor(floorsTemp, res.data, floorIndex, areaIndex)
        } else {
          Toast.hide()
          Toast.info(intl.get('NoWardInfo'), 1)
        }
      } else if (res.code) {
        if (Number(res.code) === 2000) {
          redirectToAuth()
        } else {
          console.log(res)
          Toast.hide()
          Toast.info(intl.get('NoWardInfo'), 1)
        }
      } else {
        console.log(res)
        Toast.hide()
        Toast.info(intl.get('NoWardInfo'), 1)
      }
    }).catch((error) => {
      console.log(error)
    })
  }
  /**
   * 根据用户选择的病区去获取该楼层的所有床位
   */
  function getBedsByFloor (floorsTemp = [], areasTemp = [], floorIndex, areaIndex) {
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/lc/${areasTemp[areaIndex].id}/patposition`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (res.data) {
          handleOnGetPickerData(floorsTemp, areasTemp, res.data, floorIndex, areaIndex)
        } else {
          Toast.hide()
          Toast.info(intl.get('NoBedInfo'), 1)
        }
      } else if (res.code) {
        if (Number(res.code) === 2000) {
          redirectToAuth()
        } else {
          console.log(res)
          Toast.hide()
          Toast.info(intl.get('NoBedInfo'), 1)
        }
      } else {
        console.log(res)
        Toast.hide()
        Toast.info(intl.get('NoBedInfo'), 1)
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 返回Picker组件需要的格式的数据
   */
  function handleOnGetPickerData (floorsTemp, areasTemp, beds, floorIndex, areaIndex) {
    const floorArr = []
    floorsTemp.map((floor, index) => {
      const floorObj = {}
      floorObj.label = <div>{floor.name}</div>
      floorObj.value = JSON.stringify({ floorId: floor.id, floorName: floor.name, index: index })
      if (index === floorIndex) {
        const areasArr = []
        areasTemp.map((area, j) => {
          const areaObj = {}
          areaObj.label = <div>{area.name}</div>
          areaObj.value = JSON.stringify({ areaId: area.id, areaName: area.name, index: j })
          if (j === areaIndex) {
            const bedArr = []
            beds.map((bed) => {
              const bedObj = {}
              bedObj.label = <div>{bed.name}</div>
              bedObj.value = JSON.stringify({ bedId: bed.id, bedName: bed.name })
              bedArr.push(bedObj)
            })
            areaObj.children = bedArr
          } else {
            areaObj.children = []
          }
          areasArr.push(areaObj)
        })
        floorObj.children = areasArr
      } else {
        floorObj.children = []
      }
      floorArr.push(floorObj)
    })
    Toast.hide()
    setDataSource(floorArr)
  }
  /**
   * 当用户点击确认按钮时触发
   */
  function handleOnSubmit () {
    // console.log(number)
    // console.log(patientName)
    // console.log(selectedDietaryAdvice)
    // console.log(selectedDietaryAdviceObj)
    // console.log(area)
    // console.log(floor)
    // console.log(bedId)
    // console.log(mobile.length)
    // console.log(verificationCode)
    if (numberEditable) {
      if (number.length === 0) {
        setShowModal(true)
        setModalTitle(intl.get('Tips'))
        setModalInfo(intl.get('EnterPID'))
        setConfirmNumber(true)
        return false
      }
      if (editable) {
        if (patientName.length === 0) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(intl.get('EnterPName'))
          setConfirmName(true)
          return false
        }
        if (selectedDietaryAdvice.length === 0) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(intl.get('EnterFoodAdvice'))
          setConfirmDietaryAdvice(true)
          return false
        }
      }
      if (positionEditable) {
        if (!bedId.bedId) {
          setShowModal(true)
          setModalTitle(intl.get('Tips'))
          setModalInfo(intl.get('EnterBedInfo'))
          setConfirmPosition(true)
          return false
        } else {
          if (bedId.bedId.length === 0) {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            setModalInfo(intl.get('EnterBedInfo'))
            setConfirmPosition(true)
            return false
          }
        }
      }
    }
    if (mobile.length === 0) {
      setShowModal(true)
      setModalTitle(intl.get('Tips'))
      setModalInfo(intl.get('EnterPhone'))
      setConfirmPhone(true)
      return false
    }
    const mobileTemp = mobile.replace(/\s*/g, '')
    if (!(/^(?=\d{11}$)^1(?:3\d|4[57]|5[^4\D]|66|7[^249\D]|8\d|9[89])\d{8}$/).test(mobileTemp)) {
      setShowModal(true)
      setModalTitle(intl.get('Tips'))
      setModalInfo(intl.get('EnterRightFormatPhone'))
      setConfirmPhone(true)
      return false
    }
    if (verificationCode.length === 0) {
      setShowModal(true)
      setModalTitle(intl.get('Tips'))
      setModalInfo(intl.get('EnterCode'))
      setConfirmCode(true)
      return false
    }
    if (selected === false) {
      setShowModal(true)
      setModalTitle(intl.get('Tips'))
      setModalInfo(intl.get('SelectCheck'))
      return false
    }
    registerButton.current.disabled = true // 当用户点击了一次注册按钮后注册按钮失效
    Toast.loading('', 0)
    const data = {}
    data.mobile = mobile.replace(/\s*/g, '') // 手机号
    data.code = verificationCode // 验证码
    data.PID = number // 住院号
    const foodAdviceIdsTemp = [] // 饮食医嘱的数组
    selectedDietaryAdviceObj.map((advice) => {
      foodAdviceIdsTemp.push(advice.id)
    })
    data.foodAdviceIds = foodAdviceIdsTemp.join(' ')
    data.hisCode = HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode // 医院的hisCode
    data.patPositionID = bedId.bedId // 床位号
    data.patientName = patientName
    data.allergies = allergen
    data.type = 'type'
    data.grant_type = 'sms'
    form.append('mobile', data.mobile)
    form.append('code', data.code)
    form.append('PID', data.PID)
    form.append('foodAdviceIds', data.foodAdviceIds)
    form.append('hisCode', data.hisCode)
    form.append('patPositionID', data.patPositionID)
    form.append('patientName', data.patientName)
    form.append('allergies', data.allergies)
    form.append('type', data.type)
    form.append('grant_type', data.grant_type)
    form.append('language', Language.locale)
    const UUID = window.localStorage.getItem('sdxUUID')
    form.append('uuid', UUID)
    fetch(`${config.server}/oauth/token?client_id=${config.clientId}&client_secret=${config.clientSecret}`, {
      method: 'POST',
      body: form,
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((response) => response.json())
      .then((res) => {
        Toast.hide()
        const errorCodes = [
          '1001',
          '1002',
          '1003',
          '1004',
          '1005',
          '1006',
          '1007',
          '1008',
          '1009',
          '1010',
          '1041',
          '1042',
          '1031',
          '1021',
          '1081',
          '1082',
          '1083',
          '1084',
          '1085',
          '1086',
          '1087',
          '1088',
          '1089'
        ]

        if (res.data !== 'error' && !errorCodes.includes(res.code)) {
          const sdxUserToken = {}
          sdxUserToken.access_token = res.data.access_token
          sdxUserToken.scope = res.data.scope
          sdxUserToken.token_type = res.data.token_type
          getCurrentUserInfo(sdxUserToken)
          // const sdxHisCode = window.localStorage.getItem('sdxHisCode')
          // const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
          // window.localStorage.setItem('sdxUserToken', JSON.stringify(sdxUserToken))
          // if (sdxPatPositionId) {
          //   props.history.push(`/index/${sdxHisCode}/${sdxPatPositionId}`)
          // } else {
          //   props.history.push(`/index/${sdxHisCode}`)
          // }
        } else {
          if (errorCodes.includes(res.code)) {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            setModalInfo(res.message)
            registerButton.current.disabled = false // 因为注册失败，所以重新启用注册按钮
          } else {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            setModalInfo(intl.get('RegisterFailed'))
            console.log(`注册失败!失败原因:${res.message}`)
            registerButton.current.disabled = false // 因为注册失败，所以重新启用注册按钮
          }
        }
      }).catch((error) => {
        console.log(error)
      })
  }

  /**
   * 根据token获取当前登录人信息
   */
  function getCurrentUserInfo (sdxUserToken) {
    if (sdxUserToken) {
      fetch(`${config.server}/v1/orderers`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          Authorization: sdxUserToken.token_type + sdxUserToken.access_token,
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Accept-Language': Language.acceptLanguage
        }
      }).then((response) => response.json()).then((res) => {
        // console.log(res)
        if (res.data.language) {
          Language.setLocale(res.data.language)
        }
        if (!res.error) {
          SessionContext.setCurrentUser(res.data)
          SessionContext.setLogged(true)
          // const temp = JSON.parse(window.localStorage.getItem('sdxTokens')) || {}
          const sdxHisCode = window.localStorage.getItem('sdxHisCode')
          // const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
          const sdxUserTokensObj = {}
          sdxUserTokensObj[sdxHisCode] = sdxUserToken
          // temp[sdxHisCode] = sdxUserToken
          const tempToken = JSON.stringify(sdxUserToken)
          // window.localStorage.setItem('sdxTokens', JSON.stringify(temp))
          window.localStorage.setItem('sdxUserToken', tempToken)
          SessionContext.setCodeExist(true)
          SessionContext.setTokenExist(true)
          if (res.data.patientDTO === null) {
            setShowModal(true)
            setModalTitle(intl.get('Tips'))
            setModalInfo(intl.get('RegisteredButNotBind'))
            // SessionContext.setBinded(false)
            if (HospitalBasicInfo.basicHospitalInfo) {
              if (HospitalBasicInfo.basicHospitalInfo.properties.isSupportScan) {
                props.history.push('/tipPage/bind')
              } else {
                props.history.push('/bind')
              }
            } else {
              props.history.push('/bind')
            }
          } else {
            // if (sdxPatPositionId) {
            //   props.history.push(`/index/${sdxHisCode}/${sdxPatPositionId}`)
            // } else {
            //   props.history.push(`/index/${sdxHisCode}`)
            // }
            props.history.push(`/order`)
            SessionContext.setLogged(true)
            SessionContext.setBinded(true)
          }
        } else {
          window.localStorage.removeItem('sdxUserToken')
          SessionContext.setTokenExist(false)
          SessionContext.setLogged(false)
          SessionContext.setBinded(false)
          const defaultLanguage = navigator.language || navigator.userLanguage
          Language.setLocale(defaultLanguage.substring(0, 2))
          SessionContext.setCurrentUser({})
          // if (window.localStorage.getItem('sdxTokens')) {
          //   const sdxTokens = JSON.parse(window.localStorage.getItem('sdxTokens'))
          //   sdxTokens[props.match.params.hisCode] = undefined
          //   window.localStorage.setItem('sdxTokens', JSON.stringify(sdxTokens))
          // }
          // Toast.info('获取当前登录人信息失败!')
          if (res.message === 'invalid_token') {
            Toast.info('旧帐号已过期，请重新注册!')
            // window.localStorage.removeItem('sdxUserToken')
            // SessionContext.setLogged(false)
            // SessionContext.setBinded(false)
            // SessionContext.setCurrentUser({})
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }

  /**
   * 获取用户选择的饮食医嘱
   */
  function getSelectedFood (foodObj) {
    if (foodObj.length > 0) {
      setConfirmDietaryAdvice(false)
    } else {
      setConfirmDietaryAdvice(true)
    }
    const selectedValue = []
    const selectedAdvice = []
    const foodObjTemp = []
    foodObj.map((item) => {
      selectedValue.push(item.value)
      selectedAdvice.push(item.label)
      foodObjTemp.push({ id: item.value, value: item.label })
    })
    setDefaultValue(selectedValue)
    setSelectedDietaryAdvice(selectedAdvice)
    setSelectedDietaryAdviceObj(foodObjTemp)
    setVisible(false)
  }

  function handleOnCancel () {
    setVisible(false)
  }

  return (
    <div>
      <Styles.RegisterContainer className={'registerContainer'} style={{ height: `${deviceHeight}px` }}>
        <Styles.NavBarContainer>
          <MyHeaderBg />
          <MyNavBar
            Icon={<Icon size={'md'} color={'white'} type={'left'} />}
            rightContent={<Icon size={'md'} color={'white'} type={'cross'} />}
            history={props.history}
            titleStyle={{ fontFamily: 'YouYuan', fontSize: '1.2rem' }}
          >
            {intl.get('Binding patient')}
          </MyNavBar>
          <Styles.TelephoneServiceContainer>
            <Styles.IconContainer>
              <StaffIcon height={18} width={18} />
            </Styles.IconContainer>
            <Styles.TelephoneTextContainer>
              {intl.get('Service Hotline')}:
              {
                HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo
                  ? <a style={config.theme && { color: config.theme.textColor }} href={`tel:${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.telephone}`}>
                    <u>{HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.telephone}</u>
                  </a>
                  : ''
              }
            </Styles.TelephoneTextContainer>
          </Styles.TelephoneServiceContainer>
        </Styles.NavBarContainer>
        {/* <Styles.ContainerMiddle style={{ height: `${deviceHeight}px`, overflow: 'scroll' }}> */}
        <Styles.ContainerMiddle>
          <Styles.ContainerMiddleContent>
            <div style={{ fontSize: '1.125rem', marginTop: '20%', fontWeight: 'bold' }}>
              {intl.get('RegisterPation')}
            </div>
            <Styles.ContainerMiddleList>
              <List prefixCls={'myRegisterList'} className={'myRegisterList'}>
                {/** 住院号 */}
                <InputItem
                  editable={numberEditable}
                  value={number}
                  className={'myRegisterInput'}
                  style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
                  labelNumber={3}
                  placeholder={intl.get('HospitalizationNumber')}
                  extra={showOKButton ? <RenderNumberConfirmButton /> : null}
                  onChange={(value) => {
                    setNumber(value)
                    // setFloor({})
                    // setArea({})
                    // setBedId({})
                    // setPatientName('')
                    // setSelectedDietaryAdvice([])
                    // setSelectedDietaryAdviceObj([])
                    // setDefaultValue([])
                    // if (!HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient) {
                    //   setEditable(true)
                    //   setPositionEditable(true)
                    // } else {
                    //   setEditable(false)
                    //   setPositionEditable(false)
                    // }
                    // resetInputEditState() // 当住院号发生变化的时候，重置其他输入框的状态
                    if (value && value.length > 0) {
                      setConfirmNumber(false)
                    } else {
                      setConfirmNumber(true)
                    }
                  }}
                >
                  <Stethoscope width='40%' color={confirmNumber ? 'red' : undefined} />
                </InputItem>
                {/** 病员姓名 */}
                <InputItem
                  editable={editable}
                  className={'myRegisterInput'}
                  value={patientName}
                  onChange={(value) => {
                    setPatientName(value)
                    if (value && value.length > 0) {
                      setConfirmName(false)
                    } else {
                      setConfirmName(true)
                    }
                  }}
                  labelNumber={3}
                  placeholder={intl.get('PatientName')}
                  extra={editable ? <RenderDeleteIcon type={patientName} onClick={() => setPatientName('')} /> : null}
                  style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
                >
                  <People width='40%' color={confirmName ? 'red' : undefined} />
                </InputItem>
                {/** 饮食医嘱 */}
                <InputItem
                  className={'myRegisterInput'}
                  editable={false}
                  value={selectedDietaryAdvice}
                  labelNumber={3}
                  placeholder={intl.get('DietaryAdvice')}
                  // extra={<select
                  //   placeholder={'请选择'}
                  //   id={'foodAdvices'}
                  //   name={'foodAdvices'}
                  //   disabled={!editable}
                  //   multiple='multiple'
                  //   className={'mySelect'}
                  //   value={selectedDietaryAdvice}
                  //   onChange={handleOnSelectChange}>
                  //   {foodAdviceOptions}
                  // </select>}
                  extra={editable ? <div style={{ fontSize: '0.9rem', fontFamily: 'YouYuan', color: '#898989' }} onClick={() => setVisible(true)}>{intl.get('ChooseFoodeAdviceTip')}</div> : null}
                  style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
                >
                  <Case height={22} width={22} color={confirmDietaryAdvice ? 'red' : undefined} />
                </InputItem>

                {/* 过敏源Allergen */}
                <InputItem
                  editable={editable}
                  className={'myRegisterInput'}
                  value={allergen}
                  labelNumber={3}
                  onChange={(value) => {
                    setAllergen(value)
                  }}
                  placeholder={intl.get('Allergen')}
                  style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
                >
                  <AllergenIcon width='40%' />
                </InputItem>

                {/* 病员床位等信息 */}
                <Picker
                  okText={intl.get('OK')}
                  dismissText={intl.get('Cancel')}
                  onPickerChange={(value) => handleOnColChange(value)}
                  disabled={!positionEditable}
                  cols={3}
                  data={dataSource}
                  title={intl.get('PositionPickerTitle')}
                  cascade
                  value={selectedPosition}
                  onOk={(value) => handlePickerOnOk(value)}
                  itemStyle={{ fontSize: '0.8rem' }}
                // onDismiss={() => handlePickerOnCancel()}
                >
                  <div>
                    {/** 楼层 */}
                    <InputItem
                      editable={false}
                      className={'myRegisterInput'}
                      value={floor.floorName}
                      labelNumber={3}
                      placeholder={intl.get('Floor')}
                      extra={null}
                      style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
                    >
                      <Hospital width={'40%'} color={confirmPosition ? 'red' : undefined} />
                    </InputItem>
                    {/** 病区 */}
                    <InputItem
                      editable={false}
                      className={'myRegisterInput'}
                      value={area.areaName}
                      labelNumber={3}
                      placeholder={intl.get('InpatientWard')}
                      extra={null}
                      style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
                    >
                      <Address width={'40%'} color={confirmPosition ? 'red' : undefined} />
                    </InputItem>
                    {/** 床位 */}
                    <InputItem
                      editable={false}
                      className={'myRegisterLastInput'}
                      value={bedId.bedName}
                      labelNumber={3}
                      placeholder={intl.get('BedID')}
                      extra={null}
                      style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
                    >
                      <Bed width={'35%'} color={confirmPosition ? 'red' : undefined} />
                    </InputItem>
                  </div>
                </Picker>
              </List>
            </Styles.ContainerMiddleList>
          </Styles.ContainerMiddleContent>
          <Styles.ContainerBottomContent>
            <Styles.BottomTitle>
              {intl.get('BindUser')}
            </Styles.BottomTitle>
            <List prefixCls={'myRegisterList'} className={'myRegisterList'}>
              {/** 手机号码 */}
              <InputItem
                ref={inputTelephone}
                type={'phone'}
                className={'myRegisterInput'}
                value={mobile}
                onChange={(value) => {
                  setMobile(value)
                  if (value && value.length > 0) {
                    setConfirmPhone(false)
                  } else {
                    setConfirmPhone(true)
                  }
                }}
                labelNumber={3}
                placeholder={intl.get('EnterPhoneNumber')}
                extra={startCount ? <RenderSeconds handleOnEndCount={handleOnEndCount} handleOnGetVerificationCode={handleOnGetVerificationCode} /> : <div onClick={() => handleOnGetVerificationCode()} style={{ fontSize: '0.7rem' }} className={'registerClock'}>{intl.get('GetVerificationCode')}</div>}
                style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
              >
                <Phone width={'38%'} color={confirmPhone ? 'red' : undefined} />
              </InputItem>
              {/** 验证码 */}
              <InputItem
                ref={inputCode}
                className={'myRegisterLastInput'}
                value={verificationCode}
                onChange={(value) => {
                  setVerificationCode(value)
                  if (value && value.length > 0) {
                    setConfirmCode(false)
                  } else {
                    setConfirmCode(true)
                  }
                }}
                labelNumber={3}
                placeholder={intl.get('InputVerificationCode')}
                extra={<RenderDeleteIcon type={verificationCode} onClick={() => setVerificationCode('')} />}
                style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989' }}
              >
                <Lock width={'38%'} color={confirmCode ? 'red' : undefined} />
              </InputItem>
            </List>
            <AgreeItem
              checked={selected}
              className={'registerCheckbox'}
              data-seed='logId'
              onChange={e => setSelected(e.target.checked)}

            >
              <span style={{ fontSize: '1rem' }}>{intl.get('AgreeService')}</span>
              <span
                onClick={(e) => {
                  e.preventDefault()
                  setShowClause(true)
                }}
                style={{ color: '#4698FA', fontSize: '1rem' }}
              >{intl.get('TermsAndConditions')}</span>
              <span style={{ fontSize: '1rem' }}>{intl.get('and')}</span>
              <span
                onClick={(e) => {
                  e.preventDefault()
                  setShowPrivacyPolicy(true)
                }}
                style={{ color: '#4698FA', fontSize: '1rem' }}
              >{intl.get('privacyPolicy')}</span>
            </AgreeItem>
          </Styles.ContainerBottomContent>
          {/** 确认按钮 */}
          <Styles.RegisterButtonsContainer>
            <Styles.ButtonSubmit ref={registerButton} onClick={() => handleOnSubmit()}>{intl.get('Confirm')}</Styles.ButtonSubmit>
          </Styles.RegisterButtonsContainer>
        </Styles.ContainerMiddle>

        <MyModal
          visible={showModal}
          title={modalTitle}
          info={modalInfo}
          cancelButtonVisible={false}
          onOkClick={() => setShowModal(false)}
        />
        <Modal
          className={'myUserTermModal'}
          style={{ width: 350 }}
          visible={showClause}
          maskClosable={false}
          title={<span style={{ fontSize: '1rem' }}>{intl.get('UserTerms')}</span>}
          // onClose={() => setShowClause(false)}
          // closable
          // popup
          transparent
          footer={[{ text: intl.get('Confirm'), onPress: () => setShowClause(false) }]}
        >
          <div dangerouslySetInnerHTML={{ __html: userTerm }} style={{ textAlign: 'left', maxHeight: 400, fontSize: '1rem' }}>
            {/* {userTerm} */}
          </div>
        </Modal>
        <Modal
          className={'myPrivacyPolicyModal'}
          style={{ width: 350 }}
          visible={showPrivacyPolicy}
          maskClosable={false}
          title={<span style={{ fontSize: '1rem' }}>{intl.get('privacyPolicy')}</span>}
          // onClose={() => setShowClause(false)}
          // closable
          // popup
          transparent
          footer={[{ text: intl.get('Confirm'), onPress: () => setShowPrivacyPolicy(false) }]}
        >
          <PrivacyPolicy />
        </Modal>
        <MyModal
          visible={showPatientInfoModal}
          title={modalTitle}
          info={modalInfo}
          cancelButtonVisible
          onCancelClick={() => {
            setIfShowPickerView(true)
            setShowPatientInfoModal(false)
          }}
          onOkClick={() => { // 确定选择某个病人
            setShowPatientInfoModal(false)
            setFlag(true)
            SessionContext.setPatientInfo([selectedPatient])
            setPatientInfo(selectedPatient) // 填充病员所有信息
            setNumberEditable(false) // 禁止修改住院号
            setEditable(false) // 禁止修改用户名和饮食医嘱
            setPositionEditable(false) // 禁止修改床位信息
          }}
        />
        <MyModal
          visible={showRefuseToChoosePatientModal}
          title={modalTitle}
          info={modalInfo}
          cancelButtonVisible
          onCancelClick={() => {
            setIfShowPickerView(true)
            setShowRefuseToChoosePatientModal(false)
          }}
          onOkClick={() => {
            setShowRefuseToChoosePatientModal(false)
            SessionContext.setPatientInfo([])
            // if (JSON.stringify(SessionContext.patientInfoByWristband) !== '{}') {
            //   SessionContext.patientInfoByWristband({})
            // }
          }}
        />
        <Picker
          className={'choosePatient'}
          title={<div style={{ fontSize: '1.2rem' }}>{intl.get('SelectPatient')}</div>}
          data={pickerData}
          visible={ifShowPickerView}
          cascade
          cols={1}
          onOk={(value) => handleOnSelectPatient(value)}
          onDismiss={() => handleOnRefuseChoosePatient()}
          okText={intl.get('OK')}
          dismissText={intl.get('Cancel')}
        />
      </Styles.RegisterContainer>
      <IndexList
        defaultValue={defaultValue}
        visible={visible}
        dataSource={foodAdviceDataSource}
        handleOnOkClick={(foodObj) => getSelectedFood(foodObj)}
        handleOnCancelClick={(foodObj) => getSelectedFood(foodObj)}
        onCancel={() => handleOnCancel()}
      />
    </div>
  )
}
